<template>
  <div class="survey-forms-table">
    <div class="topbar-bottom">
      <div class="search">
        <search placeholder="请输入名称" @search="search" />
      </div>
      <div class="select">
        <el-select v-model="createBy" placeholder="发布人" @change="createByChange">
          <el-option :label="item.dictLabel" :value="item.dictLabel" v-for="(item, index) in createByList"
            :key="index"></el-option>
        </el-select>
      </div>
    </div>
    <div class="survey-forms-list">
      <el-table :data="surveyFormsList" style="width: 100%; overflow: auto;">
        <el-table-column prop="formName" label="名称" width="400">
        </el-table-column>
        <el-table-column prop="time" label="填写时间">
          <template slot-scope="scope">
            {{ scope.row.startTime + " - " + scope.row.endTime }}
          </template>
        </el-table-column>
        <el-table-column label="模板分类">
          <template slot-scope="scope">
            {{ questionnaireTypeList[scope.row.templateType - 1].dictLabel }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="createBy" label="创建人">
        </el-table-column>
        <el-table-column prop="createTime" label="发起时间">
        </el-table-column> -->
        <el-table-column label="操作" fixed="right" width="350">
          <template slot-scope="scope">
            <div class="operate">
              <!-- 统计结果 -->
              <el-button type="warning" size="small" @click="statisticalResultClick(scope.row)">统计反馈
              </el-button>
              <!-- 详情 -->
              <el-button type="success" size="small" @click="detailClick(scope.row)" v-hasPermi="'sc:survey:query'">详情
              </el-button>
              <!-- 删除 -->
              <el-button type="danger" size="small" @click="delClick(scope.row.id)" v-hasPermi="'sc:survey:delete'">删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination :pageSize="pageSize" :total="total" @currentPageNumChange="currentPageNumChange"
      @handleSizeChange="handleSizeChange"></pagination>
    <!-- 统计结果弹窗 -->
    <statisticalResultDialog ref="statisticalResultDialog" v-show="statisticalResultDialogVisible"
      :statisticalResultDialogVisible.sync="statisticalResultDialogVisible" :surveyTableData="surveyTableData" />
  </div>
</template>

<script>
import statisticalResultDialog from "../statistical-result-dialog/statisticalResultDialog.vue";
import search from "@/components/search/search.vue";
export default {
  props: {
    total: {
      type: [Number, String],
    },
    surveyFormsList: {
      type: [Object, Array],
    },
    getSurveyFormsListResult: {
      type: [Number, String],
    },
    questionnaireTypeList: {
      type: [Object, Array],
    }
  },
  components: {
    statisticalResultDialog,
    search
  },
  data() {
    return {
      pageSize: 10,
      surveyTableData: null,
      statisticalResultDialogVisible: false,
      createByList: [{
        dictLabel: "全部",
      },
      {
        dictLabel: "我发布的",
      }],
      createBy: "全部",
    };
  },
  methods: {
    createByChange(e) {
      if (e == '全部') {
        this.$emit("createByChange", '');
      } else {
        this.$emit("createByChange", this.user.id);
      };
    },
    search(e) {
      this.$emit("search", e);
    },
    currentPageNumChange(e) {
      this.$emit("currentSurveyFormsList", e);
    },
    handleSizeChange(pageSize) {
      this.$emit("currentSurveyFormsListPageSize", pageSize);
    },
    statisticalResultClick(data) {
      this.surveyTableData = data;
      this.$refs.statisticalResultDialog.ruleForm.remark = data.remark;
      this.statisticalResultDialogVisible = true;
    },
    detailClick(data) {
      this.$router.push({
        path: "/survey-table-detail",
        query: {
          surveyTableData: JSON.stringify(data),
        },
      });
    },
    delClick(id) {
      this.$confirm("是否删除该统计表?", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          this.delete(this.$url.delSurveyForms + "/" + id).then((res) => {
            if (res.code !== 200) return this.$message.error(res.msg);
            this.$message.success(res.msg);
            this.$emit("currentSurveyFormsList", 1);
          });
        })
        .catch(() => { });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./surveyFormsTable.scss";
</style>